(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hg-home-01"] && !Shopify.designMode) return;
  try {
    
function hgHomeReviewsInit(){document.querySelectorAll('[data-hg-home-reviews]').forEach(function(root){if(root.dataset.ready)return;root.dataset.ready='true';root.querySelectorAll('[data-hg-home-dot]').forEach(function(button){button.addEventListener('click',function(){var selected=button.dataset.hgHomeDot;root.querySelectorAll('[data-hg-home-slide]').forEach(function(slide){slide.hidden=slide.dataset.hgHomeSlide!==selected});root.querySelectorAll('[data-hg-home-dot]').forEach(function(dot){dot.setAttribute('aria-pressed',String(dot===button))})})})})}
hgHomeReviewsInit();document.addEventListener('shopify:section:load',hgHomeReviewsInit);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hg-mask-product"] && !Shopify.designMode) return;
  try {
    
function initializeMaskSliders(scope) {
  scope.querySelectorAll('.mask-gallery').forEach(gallery => {
    if (gallery.dataset.maskSliderReady) return;
    const track = gallery.querySelector('.mask-photos');
    const thumbs = Array.from(gallery.querySelectorAll('.mask-thumb'));
    const previous = gallery.querySelector('.mask-slide-prev');
    const next = gallery.querySelector('.mask-slide-next');
    if (!track || !thumbs.length || !previous || !next) return;
    gallery.dataset.maskSliderReady = 'true';
    let selected = 0;
    const update = index => {
      selected = Math.max(0, Math.min(thumbs.length - 1, index));
      thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === selected)));
      previous.disabled = selected === 0;
      next.disabled = selected === thumbs.length - 1;
    };
    const show = index => {
      update(index);
      track.scrollTo({left: track.clientWidth * selected, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    };
    thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => show(i)));
    previous.addEventListener('click', () => show(selected - 1));
    next.addEventListener('click', () => show(selected + 1));
    track.addEventListener('scroll', () => update(Math.round(track.scrollLeft / track.clientWidth)), {passive: true});
    track.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        show(selected + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    new ResizeObserver(() => track.scrollTo({left: track.clientWidth * selected, behavior: 'instant'})).observe(track);
    update(0);
  });
}
initializeMaskSliders(document);
document.addEventListener('shopify:section:load', event => initializeMaskSliders(event.target));

  } catch(e) { console.error(e); }
})();
})();
